import { render, staticRenderFns } from "./PasswordRecoveryChange.vue?vue&type=template&id=17c4b09a&scoped=true"
import script from "./PasswordRecoveryChange.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryChange.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoveryChange.vue?vue&type=style&index=0&id=17c4b09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c4b09a",
  null
  
)

export default component.exports